// external
import { writable } from 'svelte/store';
// lib
import { ajaxRequestor, getApiHost } from '../../../utils/index.js';
// data
import { offersEndpoints, offersBundleEndpoints } from '../data/index.js';
import { RetailerPartnerType } from '../enum/index.js';
let state = {
    retailerIntegration: RetailerPartnerType.NONE,
    isBundle: false,
    endpoint: '',
    collections: {}
};
const store = writable(state);
/**
 * `init` initializes the store with additional
 * IOffersState properties and initializes the
 * collections with an array of objects with product ids
 * @param {IOfferState} config: Partial of {@link IOfferstate}
 * @param {Array} collectionsInit: { id: string, productIds: number[] }[]
 * @returns Promise<void>
 */
const init = (config, collectionsInit) => {
    const offersEndpoint = config.isBundle
        ? offersBundleEndpoints
        : offersEndpoints;
    const { retailerIntegration = RetailerPartnerType.NONE, endpoint } = config;
    const finalEndpoint = endpoint ?? `${getApiHost()}${offersEndpoint[retailerIntegration]}`;
    const collections = collectionsInit.reduce((acc, item) => ({
        ...acc,
        [item.id.toString()]: item.productIds.map((productId) => ({
            productId,
            offers: []
        }))
    }), {});
    state = {
        ...state,
        ...config,
        endpoint: finalEndpoint,
        collections
    };
    store.set(state);
};
const updateOffersCollectionsOffers = (offers) => {
    const offersCollections = state.collections['cart'];
    offersCollections.map((offerCollection, index) => {
        const item = offers[index];
        offerCollection.offers.push({
            id: `${item.id}`,
            imageUrl: `${item.imageSourcesArray[0].url}`,
            ingredientId: `${item.ingredientId}`,
            ingredientName: `${item.name}`,
            name: `${item.subhead}`,
            price: `${item.price}`,
            productUrl: "",
            upc: `${item.id}`,
        });
        if (item.altProducts && item.altProducts.length > 0) {
            const altOffers = item.altProducts;
            altOffers.forEach(offer => {
                const altOffer = offer;
                offerCollection.offers.push({
                    id: `${altOffer.id}`,
                    imageUrl: `${altOffer.imageUrl || altOffer.imageSourcesArray[0].url}`,
                    ingredientId: `${altOffer.ingredientId}`,
                    ingredientName: `${altOffer.name}`,
                    name: `${altOffer.subhead}`,
                    price: `${altOffer.price}`,
                    productUrl: '',
                    upc: `${altOffer.id}`
                });
            });
        }
    });
};
/**
 * `fetchOffersForId` gets all offers for a product from a specific store
 * @param {string} id - the product id to fetch offers for
 * @param {string} locationId - the store location to get offers from
 */
const fetchOffersForId = async (id, locationId, limit = 5) => {
    try {
        if (state.endpoint === '') {
            throw new Error(`ERROR: no offers endpoint available for ${state.retailerIntegration}`);
        }
        const collection = state.collections[id];
        if (!collection) {
            throw new Error(`ERROR: no offers collection initialized for ${id}`);
        }
        const ingredientIds = collection.map((item) => {
            return item.productId;
        });
        const payload = {
            ingredientIds,
            limit: limit,
            locationId
        };
        const offers = await fetchOffers(payload);
        state.collections[id] = collection.map((item) => {
            item.offers = offers.filter((offer) => {
                if (item.productId &&
                    offer.ingredientId === item.productId.toString()) {
                    return offer;
                }
            });
            return item;
        });
        store.set(state);
    }
    catch (err) {
        throw err;
    }
};
/**
 * `fetchOffers` performs the ajax call to retrieve offers
 * @param {IOffersRequest} payload - the request payload {@link IOffersRequest}
 * @returns Promise<void>
 */
const fetchOffers = async (payload) => {
    try {
        const options = {
            body: JSON.stringify(payload)
        };
        const response = await ajaxRequestor.post(state.endpoint, options, true);
        const offers = response.offers.map((offer) => {
            return offer;
        });
        return offers;
    }
    catch (err) {
        throw err;
    }
};
const { set, subscribe, update } = store;
export default {
    set,
    subscribe,
    update,
    init,
    fetchOffersForId,
    updateOffersCollectionsOffers
};
